export const numberingSystems = require('cldr-data/supplemental/numberingSystems.json');
export const caGregorian = require('cldr-data/main/pt/ca-gregorian.json');
export const numbers = require('cldr-data/main/pt/numbers.json');
export const timeZoneNames = require('cldr-data/main/pt/timeZoneNames.json')

export const l10n = {
  pt: {
    schedule: {
      day: 'dia',
      week: 'semana',
      workWeek: 'Semana de trabalho',
      month: 'Mês',
      agenda: 'Agenda',
      weekAgenda: 'Agenda de da semana',
      workWeekAgenda: 'Agenda da Semana de Trabalho',
      monthAgenda: 'Agenda do mês',
      today: 'Hoje',
      noEvents: 'Sem eventos',
      allDay: 'Todo o dia',
      start: 'Início',
      end: 'Fim',
      more: 'Mais',
      close: 'Fechar',
      cancel: 'Cancelar',
      noTitle: '(Sem título)',
      delete: 'Apagar',
      deleteEvent: 'Excluir evento',
      selectedItems: 'Itens selecionados',
      deleteSeries: 'Apagar série',
      edit: 'Editar',
      editSeries: 'Editar série',
      editEvent: 'Editar evento',
      createEvent: 'Criar',
      subject: 'Assunto',
      addTitle: 'Adicionar título',
      moreDetails: 'Mais detalhes',
      save: 'Salvar',
      editContent: 'Deseja editar apenas este evento ou toda a série?',
      deleteRecurrenceContent:
        'Deseja eliminar só este evento ou toda a série?',
      deleteContent: 'Tem certeza que deseja apagar este evento?',
      newEvent: 'Novo evento',
      title: 'Título',
      location: 'Localização',
      description: 'Descrição',
      timezone: 'Time Zone',
      startTimezone: 'Hora inicial',
      endTimezone: 'Hora final',
      repeat: 'Repetir',
      saveButton: 'Salvar',
      cancelButton: 'Cancelar',
      deleteButton: 'Apagar',
      recurrence: 'Recorrência',
      editRecurrence: 'Editar recorrência',
      repeats: 'Repete',
      alert: 'Alerta',
      startEndError:
        'A data de finalização selecionada ocorre antes da da de início.',
      invalidDateError: 'O valor da data é invalida.',
      ok: 'Confirmar',
      occurrence: 'Ocorrência',
      series: 'Série',
      previous: 'Anterior',
      next: 'Próximo',
      timelineDay: 'Alocação de Hoje',
      timelineWeek: 'Alocação Semanal',
      timelineWorkWeek: 'Alocação do trabalho semanal',
      timelineMonth: 'Alocação mensal',
    },
    recurrenceeditor: {
      none: 'Nenhum',
      daily: 'Diário',
      weekly: 'Semanal',
      monthly: 'Mensal',
      month: 'Mês',
      yearly: 'Anual',
      never: 'Nunca',
      until: 'Até',
      count: 'Contar',
      first: 'Primeiro',
      second: 'Segundo',
      third: 'Terceiro',
      fourth: 'Quarto',
      last: 'Último',
      repeat: 'Repetir',
      repeatEvery: 'Repita cada',
      on: 'Repita en',
      end: 'Fim',
      onDay: 'Dia',
      days: 'Dias)',
      weeks: 'Semanas)',
      months: 'Meses)',
      years: 'Anos)',
      every: 'cada',
      summaryTimes: 'vezes)',
      summaryOn: 'em',
      summaryUntil: 'até',
      summaryRepeat: 'Repita',
      summaryDay: 'dias)',
      summaryWeek: 'semanas)',
      summaryMonth: 'meses)',
      summaryYear: 'anos)',
      monthWeek: 'Semana mensal',
      monthPosition: 'Posição da lua',
      monthExpander: 'Expansões do mês',
      yearExpander: 'Expansão do ano',
      repeatInterval: 'Repetir intervalo',
    },
    calendar: {
      today: 'Hoje',
    },
  },
}

